import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import { App as AntdApp, ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import moment from 'moment';
import 'moment/locale/zh-cn';
import { ThemeConfig } from '@/global/ThemeConfig';
import App from './App';
import 'antd/dist/reset.css';
import './utils/global';
import './styles/index.less';
import './global.css';

dayjs.locale('zh-cn');
moment.locale('zh-cn');

const loadingHtml = `
  <div id="loading-wrapper">
    <div id="loading-text">系统正在初始化<span class="loading-dots"></span></div>
  </div>
`;
document.body.insertAdjacentHTML('afterbegin', loadingHtml);

const removeLoading = () => {
  const loadingElement = document.getElementById('loading-wrapper');
  if (loadingElement) {
    loadingElement.style.opacity = '0';
    loadingElement.style.transition = 'opacity 0.5s';
    setTimeout(() => loadingElement.remove(), 500);
  }
};

document.documentElement.style.setProperty(
  '--sparrow-primary-color',
  ThemeConfig.primaryButtonBackgroundColor,
);

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <Suspense fallback={null}>
    <HashRouter>
      <ConfigProvider
        locale={zhCN}
        theme={{
          token: {
            colorPrimary: ThemeConfig.primaryButtonBackgroundColor,
            colorTextPlaceholder: ThemeConfig.placeholderTextColor,
          },
        }}
      >
        <AntdApp>
          <App onLoad={removeLoading} />
        </AntdApp>
      </ConfigProvider>
    </HashRouter>
  </Suspense>,
);
